var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"rootElement",staticClass:"mark-c2p",on:{"click":function($event){return _vm.$emit('click')}}},[_c('src-mark',{attrs:{"card-brands":_vm.cardBrands,"height":_vm.height,"width":_vm.width >= 178? _vm.width: 178}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }